import { FC } from 'react';

import { Link } from '@inertiajs/react';
import { Plus, Tag } from 'lucide-react';

import { Button } from '../../../../components/ui/Button';
import { Routes } from '../../../../models/routes';

export const EmptyState: FC = () => {
    return (
        <>
            <div className="rounded-2xl border bg-muted/10 py-12 text-center">
                <div className="mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-muted">
                    <Tag className="h-6 w-6 text-muted-foreground" />
                </div>
                <h3 className="mb-1 text-lg font-medium">
                    Пропозиції не знайдено
                </h3>
                <p className="mb-4 text-sm text-muted-foreground">
                    Пропозиції за заданим статусом та пошуком не знайдено
                </p>
                <Button asChild>
                    <Link href={Routes.NewOffer}>
                        <Plus className="mr-2 h-4 w-4" />
                        Створити нову пропозицію
                    </Link>
                </Button>
            </div>
        </>
    );
};
